import {FileClient, RestClient} from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080070FindRequest = { shukashijiYmd: string } & Partial<{
  juchuYmd: string;
  nohinyoteiYmd: string;
  shukayoteiYmd: string;
  shijikaisu: string;
  batchNo: string;
  haisorouteNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shohinCd: string;
  janCd: string;
  juchudenpyoNo: string;
  shohinshubetsuKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B080070FindResponse = {
  haisorouteNoFormat: string;
  tokuiCdFormat: string;
  nonyuCdFormat: string;
  shohinCd: string;
  shukayoteisu: string;
  shukasu: string;
  gentanka: string;
  juchuYmdFormat: string;
  nohinyoteiYmdFormat: string;
  shukayoteiYmdFormat: string;
  juchudenpyoNo: string;
  shukajokyo: string;
  suryoteisei: string;
  shohinshubetsuKbnFormat: string;
  juchugyoNo: string;
  meisaibiko: string;
  ppshiji: string;
  netsukeshiji: string;
  setshohinCd: string;
  setshohinNm: string;
  sethingentanka: string;
  setgyobiko: string;
  shainCd: string;
  shainNm: string;
};

//検索処理
export const B080070Find = (props: B080070FindRequest) => {
  return RestClient.get<PageableResponse<B080070FindResponse[]>>(
    "b080070/find",
    {
      params: props,
    }
  );
};

export type B080070ExcelRequest = { shukashijiYmd: string } & Partial<{
  juchuYmd: string;
  nohinyoteiYmd: string;
  shukayoteiYmd: string;
  shijikaisu: string;
  batchNo: string;
  haisorouteNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shohinCd: string;
  janCd: string;
  juchudenpyoNo: string;
  shohinshubetsuKbn: string;
}>;

// Excel出力処理
export const B080070GetExcel = (props: B080070ExcelRequest) => {
  return FileClient.get("b080070/get/excel", {
    params: props,
  });
};
